import React from 'react';
import styles from './TrafficNumber.module.scss';
import { Container, Row } from 'reactstrap';
import DataTable from 'react-data-table-component';

const trafficData = [
    {
        id: 1,
        month: 'January',
        uniqueVisitors: '10,000',
        pageViews: '50,000',
        conversionRate: '3%',
    },
    {
        id: 2,
        month: 'February',
        uniqueVisitors: '10,000',
        pageViews: '50,000',
        conversionRate: '3%',
    },
    {
        id: 3,
        month: 'March',
        uniqueVisitors: '10,000',
        pageViews: '50,000',
        conversionRate: '3%',
    },
    {
        id: 4,
        month: 'April',
        uniqueVisitors: '10,000',
        pageViews: '50,000',
        conversionRate: '3%',
    },
    {
        id: 5,
        month: 'May',
        uniqueVisitors: '10,000',
        pageViews: '50,000',
        conversionRate: '3%',
    },
];

const trafficColumns = [
    {
        name: "Month",
        selector: (row) => row.month,
    },
    {
        name: "Unique Visitors",
        selector: (row) => row.uniqueVisitors,
    },
    {
        name: "Page Views",
        selector: (row) => row.pageViews,
    },
    {
        name: "Conversion Rate",
        selector: (row) => row.conversionRate,
    },
];

const customStyles = {
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            fontSize: '15px',
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 20px',
        },
    },
};

const TrafficNumber = () => {
    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.tableSection}>
                <div className={styles.sectionTitle}>
                    <h5 className={styles.sectionSubHeading}>Number of Traffic</h5>
                </div>

                <div className={styles.tableDataWrapper}>
                    <Row className={styles.tableDataRow}>
                        <DataTable
                            columns={trafficColumns}
                            data={trafficData}
                            customStyles={customStyles}
                        />
                    </Row>
                </div>
            </Container>

            <h5 className={styles.sectionHeading}>Graphs:</h5>
            <Container fluid className={styles.graphSection}>
                <p>Traffic Overview:</p>
                <ul>
                    <li>A bar graph comparing unique visitors and page views over the past months.</li>
                </ul>
            </Container>
        </div>
    )
}

export default TrafficNumber;